import React, { useMemo } from 'react';
import cn from 'classnames';
import FullWithModal from '@components/common/Modal/FullWidthModal';
import { CUSTOM_MESSAGES, LABEL } from '../../../veriables';
import KeyboardForOrder from '../keyboardForOrderMenu';
import ModalHeader from '../../common/ModalHeader/index';

const AddSeatModal = ({
  isModalOpen,
  closeModal,
  submitSeatNumber,
  serverAppTheme,
  ...props
}) => {
  const popUpModal = useMemo(() => {
    const modal = {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      pointerEvents: 'auto',
      backgroundColor: serverAppTheme?.popUp_bg,
      backgroundClip: 'padding-box',
      height: '100%',
      border: serverAppTheme?.popupBorder,
      boxShadow: serverAppTheme?.popUp_box_shadow,
    };
    const closeIcon = {
      right: '16px',
      top: props.isLandScape ? '8px' : '14px',
      zIndex: '999',
      color: serverAppTheme?.iconcolor,
    };
    const primaryTextColor = { color: serverAppTheme?.primary_text };

    return { modal, closeIcon, primaryTextColor };
  }, [serverAppTheme, props.isLandScape]);

  return (
    <FullWithModal
      isOpen={isModalOpen}
      loading={props.loading}
      customClass2={cn('w-100 h-100')}
      style={popUpModal.modal}
      noBackground
    >
      <div
        className="col-12 px-0 h-100 justify-content-center align-items-center position-relative text-center"
        style={popUpModal.primaryTextColor}
      >
        <div
          className={cn(
            'col-12 px-0 fs_18 d-flex align-items-center justify-content-center fw-600'
          )}
        >
          <ModalHeader
            isTab={props.check?.tab}
            stationName={props.check?.stationName}
            tileHeader={LABEL().ADD_SEAT}
            seatNumber={props.check?.number}
          />
        </div>
        {/* <div className='fs_18 fw-600 text-center py-2'>{LABEL().ADD_SEAT_TITLE}</div> */}
        <KeyboardForOrder
          name="seatNumber"
          type="numericWithBin"
          placeholder={CUSTOM_MESSAGES().ENTER_SEAT_NUMBER}
          isOpen={isModalOpen}
          customClass="mt-2"
          specialValue=""
          check={props.check}
          buttonName={LABEL().OCCUPY_SEAT}
          onSubmit={submitSeatNumber}
          serverAppTheme={serverAppTheme}
          screenType="AddSeats"
          cancelBtnName={LABEL().CANCEL}
          onCancel={() => closeModal()}
          setErrorPopUp={props.setErrorPopUp}
        />
      </div>
    </FullWithModal>
  );
};

export default AddSeatModal;
